export const LOCALES = [
  { key: 'ma-fr',    label: 'Maroc — Français',    flag: '🇲🇦', dir: 'ltr', country: 'MA'    },
  { key: 'ma-ar',    label: 'المغرب — العربية',     flag: '🇲🇦', dir: 'rtl', country: 'MA'    },
  { key: 'ma-en',    label: 'Morocco — English',    flag: '🇲🇦', dir: 'ltr', country: 'MA'    },
  { key: 'tn-fr',    label: 'Tunisie — Français',   flag: '🇹🇳', dir: 'ltr', country: 'TN'    },
  { key: 'tn-ar',    label: 'تونس — العربية',       flag: '🇹🇳', dir: 'rtl', country: 'TN'    },
  { key: 'tn-en',    label: 'Tunisia — English',    flag: '🇹🇳', dir: 'ltr', country: 'TN'    },
  { key: 'dz-fr',    label: 'Algérie — Français',   flag: '🇩🇿', dir: 'ltr', country: 'DZ'    },
  { key: 'dz-ar',    label: 'الجزائر — العربية',    flag: '🇩🇿', dir: 'rtl', country: 'DZ'    },
  { key: 'dz-en',    label: 'Algeria — English',    flag: '🇩🇿', dir: 'ltr', country: 'DZ'    },
  { key: 'fr-fr',    label: 'France — Français',    flag: '🇫🇷', dir: 'ltr', country: 'FR'    },
  { key: 'fr-ar',    label: 'France — عربية',       flag: '🇫🇷', dir: 'rtl', country: 'FR'    },
  { key: 'fr-en',    label: 'France — English',     flag: '🇫🇷', dir: 'ltr', country: 'FR'    },
  { key: 'world-fr', label: 'Monde — Français',     flag: '🌍',  dir: 'ltr', country: 'WORLD' },
  { key: 'world-ar', label: 'العالم — العربية',      flag: '🌍',  dir: 'rtl', country: 'WORLD' },
  { key: 'world-en', label: 'Worldwide — English',  flag: '🌍',  dir: 'ltr', country: 'WORLD' },
];

export const COUNTRY_TO_LOCALE = {
  MA: 'ma-fr',
  TN: 'tn-fr',
  DZ: 'dz-fr',
  FR: 'fr-fr',
};

export const DEFAULT_LOCALE = 'world-en';
